<script lang="ts" setup>
  import type { Toast } from '~/core/types'

  type Props = {
    content: Toast
    iframe?: boolean
  }

  const props = defineProps<Props>()

  const emit = defineEmits<{
    (e: 'close'): void
  }>()

  function close(): void {
    emit('close')
  }

</script>
<template>
  <div
    class="lc-toast"
    :class="[{displayed: props.content.displayed, iframe:props.iframe}, props.content.type]"
    @click="close"
  >
    <span>{{ props.content.content }}&nbsp;</span>
    <slot />
  </div>
</template>
<style scoped>
.lc-toast {
  position: absolute;
  z-index: 30;
  top: 62px;
  display: flex;
  overflow: hidden;
  width: 100%;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  transform: translateY(-100%);
  transition: transform ease 0.5s;

  &.iframe{
    top: 0;
  }

  > span {
    display: flex;
    width: 100vw;
    height: auto;
    box-sizing: border-box;
    justify-content: center;
    padding: 0.5em 1em;
    box-shadow: var(--box-shadow-1);
    color: var(--color-secondary);
    font-family: Open-Sans, sans-serif;
    font-size: 1em;
  }

  &.success > span {
    background-color: var(--color-primary);
  }

  &.warning > span {
    background-color: var(--color-warning);
  }

  &.error > span {
    background-color: var(--color-error);
  }

  &.displayed {
    transform: translateY(0)
  }

  @media screen and (width >= 1024px) {
    top: 90px;

    &.iframe{
      top: 0;
    }
  }
}
</style>
